import { Avatar } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { useMemo } from "react";

function stringToColor(value: string) {
  let hash = 0;

  for (let i = 0; i < value.length; i += 1) {
    hash = value.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";

  for (let i = 0; i < 3; i += 1) {
    const component = (hash >> (i * 8)) & 0xff;
    color += `00${component.toString(16)}`.slice(-2);
  }

  return color;
}

function HeaderAvatar({
  name,
  size = "medium",
  variant = "solid",
}: {
  name: string;
  size?: "medium" | "small";
  variant?: "solid" | "light";
}) {
  const stringAvatar = useMemo(() => {
    const parts = name.split(" ");
    if (!parts || parts.length === 0) {
      return {};
    }

    const color = stringToColor(name);
    const dimension = size === "small" ? 20 : 30;

    if (variant === "light") {
      return {
        sx: {
          bgcolor: alpha(color, 0.14),
          color,
          fontWeight: 600,
          width: dimension,
          height: dimension,
          fontSize: size === "small" ? 10 : 12,
        },
        children: `${parts[0][0]}${parts.length > 1 ? parts[1][0] : ""}`,
      };
    }

    return {
      sx: {
        bgcolor: color,
        width: dimension,
        height: dimension,
      },
      children: `${parts[0][0]}${parts.length > 1 ? parts[1][0] : ""}`,
    };
  }, [name, size, variant]);

  return <Avatar {...stringAvatar} />;
}

export default HeaderAvatar;
